import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpEventType, HttpResponse, HttpProgressEvent } from '@angular/common/http';
// RequestOptions
import { Config } from '../../config';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError, filter, map, scan } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProjectServicesService {
  constructor(private httpClient: HttpClient, private Config: Config) { }


  getapplicationList(token: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token,
    });
    // console.log('token in service file', token);
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getApplications`,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  projectsList(token: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token,
    });
    // console.log('token in service file', token);
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/project`,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getUisetting(name: any) {
    let params = new HttpParams();
    params = params.append('name', name);
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/uisetting`,
        { headers: header, params: params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getProject(name: any) {
    let params = new HttpParams();
    params = params.append('_id', name);
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/project`,
        { headers: header, params: params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getTemplate(name: any) {
    let params = new HttpParams();
    params = params.append('name', name);
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/template`,
        { headers: header, params: params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  loadProject(project: any, projectID: any) {
    var currProID = '';
    if (project._id == undefined || project._id == null) {
      currProID = projectID;
    } else {
      currProID = project._id;
    }
    var params = {
      model: {},
      template: {},
      uiSettings: {},
    };

    return this.getProject(currProID)
      .pipe(
        map((response: any) => {
          params.model = response.record;
          return this.getTemplate(project.projectDetails.templateName);
        })
      )
      .pipe(
        map((response) => {
          params.template = response;
          return this.getUisetting(project.projectDetails.uisettingName);
        })
      )
      .pipe(
        map((response) => {
          params.uiSettings = response;
          return params;
        })
      );
  }
  addApplication(applicationData: any) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    };
    const body = applicationData;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/addApplication`,
        body,
        { headers }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  addProject(projectData: any, token: any) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    };
    const body = projectData;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/project`,
        body,
        { headers }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }


  getDesignerContent(projectData: any) {
    // let params = new HttpParams();
    // params = params.append('_id', name);
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = projectData;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getDesignerContent`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  addDesignerContent(projectData: any) {
    // let params = new HttpParams();
    // params = params.append('_id', name);
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = projectData;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/addDesignerContent`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  planNameUpdate(planDetails: any) {
    // let params = new HttpParams();
    // params = params.append('_id', name);
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = planDetails;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/updatePlanName`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  removeActiveProject(email: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = email;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/removeActiveProject`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  updateActiveProject(email: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = email;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/updateActiveProject`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  deleteActiveUser(userID: any) {
    var socketID: any = {
      userID: userID,
    };
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = socketID;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/deleteActiveUser`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getTaskPlannerList() { }
  updateProject(value1: any, value2: any) { }

  //getting the list of projects

  loadProjects(Application: any) {
    let params = new HttpParams();
    params = params.append('applicationId', Application._id);
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/project/`,
        { headers: header, params: params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  addFeedback(feedbackData: any, token: any) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    };
    const body = feedbackData;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/addFeedback`,
        body,
        { headers }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getChecklistContent(checklistData: any, token: any) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    };
    const body = checklistData;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getChecklistContent`,
        body,
        { headers }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getPublicChecklistContent(checklistData: any, token: any) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    };
    const body = checklistData;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getpublicChecklistContent`,
        body,
        { headers }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getPublicChecklists() {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    };
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getpublicChecklists`,
        { headers }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  addChecklistContent(checklistData: any) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    };
    const body = checklistData;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/addChecklist`,
        body,
        { headers }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getMynotesEditorContent(mynotesData: any, token: any) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    };
    const body = mynotesData;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getEditorContent`,
        body,
        { headers }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  addMynotesEditorContent(mynotesData: any) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    };
    const body = mynotesData;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/addEditorContent`,
        body,
        { headers }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  loadTemplates() {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/template/`,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  updateHistorySession(task: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = task;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/updateHistory`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  addHistorySession(project: any) {
    var projectID: any = {
      projectId: project,
    };
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = projectID;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/addHistory`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getHistorySession(project: any) {
    var projectID: any = {
      projectId: project,
    };
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = projectID;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getHistory`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }


  addDefectSetBug(data: any) {
    // var projectID: any = {
    //   projectId: project,
    // };
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = data;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/addDefectBug`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };


  getProjectJirabugs(project: any) {
    var projectID: any = {
      projectID: project,
    };
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = projectID;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getJiraBugsByProjectID`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };
  getDefectsSets(projectID: any) {

    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getDefectSets/?projectID=` + projectID,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };
  getBugsByDefectsSets(id: any) {

    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = { "id": id };
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getBugsByDefectSetID`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };


  updateDefectSetBugLevel(data: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = data;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/updateDefectSetBugLevel`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };


  addDefectSet(data: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = data;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/addDefectSet`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };

  addMindMappingData(data: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = data;
    return this.httpClient
      .post(
        // `${environment.baseUrl}${environment.port}${environment.baseUri}/addMindMappingJson`,
        `http://dosmartqa.stagsoftware.net:3013/ist/api/addMindMappingJson`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };

  getMindMappingData(id: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getMindMappingData/?projectID=` + id,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };
  getMoreInfoLink() {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization: token,
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/videolink/`,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getTutorialProjects() {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization: token,
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getTutorialProjects`,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getAssistantModelsData() {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getAssistantModels`,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };
  getIntelligentAssistanttoken() {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getAssistantToken`,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };

  getIntelligentAssistantcredits(token: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    let apiURL = 'https://api.openai.com/v1/usage?date=2024-06-12';
    // let apiURL = 'https://api.openai.com/dashboard/billing/credit_grants';
    // const data = {
    //   "model": userAssistantModel,
    //   "temperature": 0.1,
    //   "messages": messages
    // };
    return this.httpClient
      .get(apiURL, { headers: header })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );

  };

  triggerChatGPT(messages: any, token: any, maxtokens: any, userAssistantModel: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    let apiURL = 'https://api.openai.com/v1/chat/completions';
    const data = {
      "model": userAssistantModel,
      "temperature": 0.1,
      "stream": true,
      "messages": messages
    };
    let totalTokens = 0;
    return this.httpClient
      .post(apiURL, JSON.stringify(data), {
        headers: header,
        responseType: 'text', // Expect the response to be text
        observe: 'events',
        reportProgress: true
      })
      .pipe(
        filter((event: any) => event.type === HttpEventType.DownloadProgress || event.type === HttpEventType.Response),
        map((event: any) => {
          if (event.type === HttpEventType.DownloadProgress) {
            console.log("Streaming Data...");
            // Accumulate the received chunks as they come
            var text = event['partialText'];
            var context = this.extractContext(text);
            totalTokens = this.countTokens(text);
            return context;
          } else if (event.type === HttpEventType.Response) {
            console.log("Final Data...");
            var text = event.body;
            var context = this.extractContext(text);
            // Count the tokens in the final chunk
            totalTokens += this.countTokens(text);
            return context;
            // This is the final response when the stream completes
          }
          // return this.extractContext(newText);
          return '';
        }),
        // scan((acc, value) => acc + value, ''), // Concatenate partial responses
        catchError((error) => {
          // Handle the error, possibly rethrow or return a default value
          return throwError(error);
        })
      );
  };


  private extractContext(text: string): string {
    // console.log("STart");
    // Split the incoming text into lines
    const lines = text.split('\n').filter(line => line.trim() !== '');
    var context = '';
    // Process each line to extract the context
    for (const line of lines) {
      if (line.startsWith('data: ')) {
        const jsonString = line.substring(6); // Remove 'data: ' prefix
        try {
          const parsed = JSON.parse(jsonString);
          if (parsed.choices && parsed.choices[0] && parsed.choices[0].delta && parsed.choices[0].delta.content) {
            context += parsed.choices[0].delta.content;
          }
        } catch (e) {
          console.error('Error parsing JSON line:', line, e);
        }
      }
    }
    // console.log("END", context);
    return context;
  }


  private countTokens(text: string): number {
    // Simple token counting logic (assuming tokens are space-separated)
    return text.split(/\s+/).length;
  }

  updateUsageTokensByUser(tokens: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = tokens;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/addAssistantTokensUsage`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };

  addAssistantMessages(data: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = data;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/addAssistantMessages`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };
  addAssistantPrompts(data: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = data;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/addAssistantPrompts`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };


  getAssistantMessages(data: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = data;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getAssistantMessages`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };
  getAssistantPrompts() {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getAssistantPrompts`,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };
  checkUserOpenAiLimits() {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/checkUserOpenAiLimit`,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };

  updateUserOpenAILimit() {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/updateUserOpenAiLimit`,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };

  deleteIntelligentAssistantMessages(data: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = data;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/deleteAssistantMessages`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  };
}
